import { useLocation } from "react-router-dom";

/**
 * useQuery is hook for quickly get a url Search object in any component, its based at useLocation hook of react-router-dom
 */

export default function useQuery() {
	return new URLSearchParams(useLocation().search);
}